import { visit } from 'unist-util-visit'
import { headingRank } from 'hast-util-heading-rank'
import { toString } from 'hast-util-to-string'

export const tocReducer = (obj, { slug, text, depth }) => {
  let last = obj.items[obj.items.length - 1]
  if (last && depth > last.depth) tocReducer(last, { slug, text, depth })
  else if (depth > obj.depth) {
    obj.items.push({
      text,
      slug,
      depth,
      items: [],
    })
  }
  return obj
}

export const tocTree = (map) => {
  return map.reduce(tocReducer, { depth: -1, items: [] })
}
export const redepthTocMap = (map) => {
  const base = map.reduce((lowest, { depth }) => (depth < lowest ? depth : lowest), Infinity) - 1
  return map.map(({ slug, text, depth }) => ({ slug, text, depth: depth - base }))
}

export const tocHeadings = (map) => map.map(({ slug }) => slug)

export const toc = ({ map = [] } = {}) => {
  return (tree, file) => {
    visit(tree, 'element', (node) => {
      const depth = headingRank(node)
      if (depth) {
        const text = toString(node)
        const slug = node.properties.id
        map.push({ slug, text, depth })
      }
    })

    const tocMap = redepthTocMap(map)
    file.tocMap = tocMap
    file.tocTree = tocTree(tocMap)
  }
}
